export default [
  {
    location: "MindBytes",
    title: "Teacher",
    timeframe: "June 2020",
    info:
      "An after-school program for Middle and High Schoolers, where I teach Math and Computer Science.",
  },
  {
    location: "Rowan University",
    title: "Research Assistant",
    timeframe: "September 2020",
    info:
      "A research team working to effectively analyze chemical patents with Natural Language Processing",
  },
  {
    location: "Rowan University",
    title: "Tutor",
    timeframe: "September 2019",
    info:
      "Rowan University offers walk-in tutoring for its Computer Science Students, so I have to be on my toes about almost every class I've ever completed in order to help all visitors",
  },
];
